import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.sass'],
})
export class ErrorPageComponent implements OnInit {
  errorCode: number;
  errorMessage: string;

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.params.forEach((params: Params) => {
      this.errorCode = +params['code'];
      switch (this.errorCode) {
        case 500:
          this.errorMessage = 'Se ha producido un error inesperado';
          break;

        case 404:
          this.errorMessage = 'No se encuentra la página.';
          break;

        case 403:
        case 401:
          this.errorMessage = 'No tienes permisos para realizar esta opción';
          break;

        default:
          break;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/common/error-page/error-page.component.ts